import React, { useState, useEffect } from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import Breadcrumb from '../../components/Breadcrumb'
import "./CreateProduct.css"
import { Icon } from '@iconify/react/dist/iconify.js'
import { createNewProductApi, getCategoryApi, updateNewProductApi, getProductsApi, ImageUrl } from '../../helper/apiHelper'
import toast from 'react-hot-toast'
import { useNavigate, useLocation } from 'react-router-dom'
const initialFormData = {
    productName: '',
    category: '',
    originalPrice: '',
    currentPrice: '',
    discountPercentage: '',
    shortDescription: '',
    fullDescription: '',
    mainImage: null,
    thumbnailImages: [],
    variants: [
        { colorName: '', colorImage: null }
    ],
    specifications: [
        { label: '', value: '', type: 'rating' }
    ],
    metaTitle: '',
    metaDescription: '',
    tags: '',
    configType: 'WHATSAPP',
    redirectionLink: ''
};

const CreateProducts = () => {

    const navigate = useNavigate("")

    const location = useLocation();



    const [formData, setFormData] = useState(initialFormData);

    const [isEditing, setIsEditing] = useState(false);
    const [editingProductId, setEditingProductId] = useState(null);

    const [imagePreview, setImagePreview] = useState({
        main: null,
        thumbnails: [],
        variants: []
    });

    const [categories, setCategories] = useState([]);

    const [errors, setErrors] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);


    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await getCategoryApi();
                if (res && res.data) {
                    setCategories(res.data);
                }
            } catch (err) {
                console.error('Failed to fetch categories', err);
            }
        };

        fetchCategories();
    }, []);

    // If navigated with query params ?productId=..&editing=true, load product for editing
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const productId = params.get('productId');
        const editing = params.get('editing') === 'true';
        if (editing && productId) {
            setIsEditing(true);
            setEditingProductId(productId);

            const loadProduct = async () => {
                try {
                    const res = await getProductsApi({ categoryId: '' });
                    if (res?.data) {
                        const prod = res.data.find(p => String(p.id) === String(productId) || String(p._id) === String(productId) || String(p.id) === String(productId));
                        if (prod) {
                            setFormData({
                                productName: prod.productName || prod.name || '',
                                category: prod.category?._id || prod.category?.id || prod.category || '',
                                originalPrice: prod.originalPrice || prod.original_price || prod.price || '',
                                currentPrice: prod.currentPrice || prod.current_price || prod.price || '',
                                discountPercentage: prod.discountPercentage || 0,
                                shortDescription: prod.shortDescription || prod.short_description || '',
                                fullDescription: prod.fullDescription || prod.full_description || '',
                                mainImage: prod.mainImage || prod.main_image || null,
                                thumbnailImages: prod.thumbnailImages || prod.thumbnail_images || [],
                                variants: (prod.variants && prod.variants.length > 0) ? prod.variants.map(v => ({ colorName: v.colorName || v.color || '', colorImage: (v.colorImage || v.color_image || v.image || v.fileName || null), stock: v.stock || '' })) : [{ colorName: '', colorImage: null }],
                                specifications: prod.specifications || [{ label: '', value: '' }],
                                metaTitle: prod.metaTitle || prod.meta_title || '',
                                metaDescription: prod.metaDescription || prod.meta_description || '',
                                tags: Array.isArray(prod.tags) ? prod.tags.join(',') : (prod.tags || ''),
                                configType: prod.configType || 'WHATSAPP',
                                redirectionLink: prod.redirectionLink || prod.redirection_link || ''
                            });

                            if (prod.mainImage || prod.main_image) {
                                const img = prod.mainImage || prod.main_image;
                                setImagePreview(prev => ({ ...prev, main: `${ImageUrl}/${img}` }));
                            }

                            // Thumbnails previews
                            const thumbs = (prod.thumbnailImages || prod.thumbnail_images || []).map(img => `${ImageUrl}/${img}`);
                            // Variant previews
                            const variantPreviews = (prod.variants || []).map(v => {
                                const img = v.colorImage || v.color_image || v.image || v.fileName || null;
                                return img ? `${ImageUrl}/${img}` : null;
                            });

                            setImagePreview(prev => ({ ...prev, thumbnails: thumbs, variants: variantPreviews }));
                        }
                    }
                } catch (err) {
                    console.error('Failed to load product for editing', err);
                    toast.error('Failed to load product for editing');
                }
            };

            loadProduct();
        }
    }, [location.search]);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.productName.trim()) {
            newErrors.productName = 'Product name is required';
        }

        if (!formData.category) {
            newErrors.category = 'Category is required';
        }

        if (!formData.originalPrice || parseFloat(formData.originalPrice) <= 0) {
            newErrors.originalPrice = 'Valid original price is required';
        }

        if (!formData.currentPrice || parseFloat(formData.currentPrice) <= 0) {
            newErrors.currentPrice = 'Valid current price is required';
        }

        if (parseFloat(formData.currentPrice) > parseFloat(formData.originalPrice)) {
            newErrors.currentPrice = 'Current price cannot exceed original price';
        }

        if (parseFloat(formData.currentPrice) == parseFloat(formData.originalPrice)) {
            newErrors.currentPrice = 'Current price cannot same as original price';
        }

        if (!formData.mainImage && !isEditing) {
            newErrors.mainImage = 'Main product image is required';
        }


        if (formData.configType === 'CUSTOM' && !formData.redirectionLink.trim()) {
            newErrors.redirectionLink = 'Redirection link is required for custom config';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        // Clear error for this field
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e, type = 'main') => {
        e.preventDefault();
        setIsDragging(false);

        const files = Array.from(e.dataTransfer.files);
        const imageFiles = files.filter(file => file.type.startsWith('image/'));

        if (type === 'main' && imageFiles.length > 0) {
            const file = imageFiles[0];
            setFormData(prev => ({ ...prev, mainImage: file }));
            setImagePreview(prev => ({
                ...prev,
                main: URL.createObjectURL(file)
            }));
            setErrors(prev => ({ ...prev, mainImage: null }));
        } else if (type === 'thumbnails') {
            const newThumbnails = imageFiles.slice(0, 4 - formData.thumbnailImages.length);
            setFormData(prev => ({
                ...prev,
                thumbnailImages: [...prev.thumbnailImages, ...newThumbnails]
            }));
            const previews = newThumbnails.map(file => URL.createObjectURL(file));
            setImagePreview(prev => ({
                ...prev,
                thumbnails: [...prev.thumbnails, ...previews]
            }));
        }
    };

    const handleMainImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file size (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                setErrors(prev => ({ ...prev, mainImage: 'Image size must be less than 5MB' }));
                return;
            }
            setFormData(prev => ({ ...prev, mainImage: file }));
            setImagePreview(prev => ({
                ...prev,
                main: URL.createObjectURL(file)
            }));
            setErrors(prev => ({ ...prev, mainImage: null }));
        }
    };

    const handleThumbnailChange = (e) => {
        const files = Array.from(e.target.files);
        const imageFiles = files.filter(file => file.type.startsWith('image/'));
        const newThumbnails = imageFiles.slice(0, 4 - formData.thumbnailImages.length);

        setFormData(prev => ({
            ...prev,
            thumbnailImages: [...prev.thumbnailImages, ...newThumbnails]
        }));

        const previews = newThumbnails.map(file => URL.createObjectURL(file));
        setImagePreview(prev => ({
            ...prev,
            thumbnails: [...prev.thumbnails, ...previews]
        }));
    };

    const removeThumbnail = (index) => {
        setFormData(prev => ({
            ...prev,
            thumbnailImages: prev.thumbnailImages.filter((_, i) => i !== index)
        }));
        setImagePreview(prev => ({
            ...prev,
            thumbnails: prev.thumbnails.filter((_, i) => i !== index)
        }));
    };

    const handleVariantChange = (index, field, value) => {
        const newVariants = [...formData.variants];
        newVariants[index][field] = value;
        setFormData(prev => ({ ...prev, variants: newVariants }));
        setErrors(prev => ({ ...prev, [`variant_${index}_${field}`]: null }));
    };

    const handleVariantImageChange = (index, file) => {
        const newVariants = [...formData.variants];
        newVariants[index].colorImage = file;
        setFormData(prev => ({ ...prev, variants: newVariants }));
        setImagePreview(prev => {
            const newVarPreviews = [...(prev.variants || [])];
            newVarPreviews[index] = file ? URL.createObjectURL(file) : null;
            return { ...prev, variants: newVarPreviews };
        });
    };

    const addVariant = () => {
        setFormData(prev => ({
            ...prev,
            variants: [...prev.variants, { colorName: '', colorImage: null, stock: '' }]
        }));
    };

    const removeVariant = (index) => {
        if (formData.variants.length > 1) {
            setFormData(prev => ({
                ...prev,
                variants: prev.variants.filter((_, i) => i !== index)
            }));
        }
    };

    const handleSpecificationChange = (index, field, value) => {
        const newSpecs = [...formData.specifications];
        newSpecs[index][field] = value;
        setFormData(prev => ({ ...prev, specifications: newSpecs }));
    };

    const addSpecification = () => {
        setFormData(prev => ({
            ...prev,
            specifications: [...prev.specifications, { label: '', value: '' }]
        }));
    };

    const removeSpecification = (index) => {
        if (formData.specifications.length > 1) {
            setFormData(prev => ({
                ...prev,
                specifications: prev.specifications.filter((_, i) => i !== index)
            }));
        }
    };

    const calculateDiscount = () => {
        const original = parseFloat(formData.originalPrice);
        const current = parseFloat(formData.currentPrice);
        if (original && current && original > current) {
            const discount = Math.round(((original - current) / original) * 100);
            setFormData(prev => ({ ...prev, discountPercentage: discount }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error('Please fix all errors before submitting');
            return;
        }

        setIsSubmitting(true);

        try {
            const payload = new FormData();
            payload.append('productName', formData.productName);
            payload.append('category', formData.category);
            payload.append('originalPrice', formData.originalPrice);
            payload.append('currentPrice', formData.currentPrice);
            payload.append('discountPercentage', formData.discountPercentage || 0);
            payload.append('shortDescription', formData.shortDescription);
            payload.append('fullDescription', formData.fullDescription);
            payload.append('metaTitle', formData.metaTitle || '');
            payload.append('metaDescription', formData.metaDescription || '');
            payload.append('tags', formData.tags || '');
            payload.append('configType', formData.configType || 'WHATSAPP');
            if (formData.redirectionLink) payload.append('redirectionLink', formData.redirectionLink);

            // Images - append main image only if it's a File (new upload)
            if (formData.mainImage instanceof File) {
                payload.append('mainImage', formData.mainImage);
            } else if (!isEditing) {
                // When creating (not editing) main image must be a File
                console.warn('Main image is not a File instance. Ask user to re-upload.');
                throw 'Main image must be uploaded before publishing. Please re-upload the main image.';
            }

            const validThumbnails = (formData.thumbnailImages || []).filter(f => f instanceof File);
            validThumbnails.forEach((file) => {
                payload.append('thumbnailImages', file);
            });

            // Variants: send variants JSON and variant images separately
            const variantsForPayload = formData.variants.map(v => ({ colorName: v.colorName || '' }));
            payload.append('variants', JSON.stringify(variantsForPayload));
            formData.variants.forEach((v, idx) => {
                if (v.colorImage instanceof File) payload.append('colorImage', v.colorImage);
            });

            // Debug: print FormData entries (shows file metadata instead of [object Object])
            for (const [key, value] of payload.entries()) {
                if (value instanceof File) {
                    console.log('FormData entry:', key, { name: value.name, size: value.size, type: value.type });
                } else if (value instanceof Blob) {
                    console.log('FormData entry (blob):', key, value);
                } else {
                    console.log('FormData entry:', key, value);
                }
            }

            // Specifications
            payload.append('specifications', JSON.stringify(formData.specifications || []));

            let res;
            if (isEditing && editingProductId) {
                res = await updateNewProductApi(payload, editingProductId);
                toast.success('Product updated successfully!');
                navigate('/products-management');
            } else {
                res = await createNewProductApi(payload);
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000);
                setFormData(initialFormData);
            }



            setShowSuccessAlert(true);
            setTimeout(() => setShowSuccessAlert(false), 3000);
            setFormData(initialFormData);
            // navigate("/product-management")





            console.log('Create/Update product response:', res);
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error(typeof error === 'string' ? error : 'Error creating product. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSaveDraft = () => {
        const draft = {
            ...formData,
            mainImage: null,
            thumbnailImages: [],
            variants: formData.variants.map(v => ({ colorName: v.colorName || '', stock: v.stock || '' })),
        };
        localStorage.setItem('productDraft', JSON.stringify(draft));
        alert('Draft saved (images omitted). Please re-upload images when publishing.');
    };

    const handleClearDraft = () => {
        if (window.confirm('Are you sure you want to clear the draft?')) {
            localStorage.removeItem('productDraft');
            window.location.reload();
        }
    };
    const formatPrice = (value) => {
        if (!value) return '';
        return Number(value).toFixed(2);
    };

    const formatPercentage = (value) => {
        if (!value) return '0';
        return Number(value).toFixed(2);
    };

    return (
        <MasterLayout>
            <Breadcrumb title="Create Products" />

            <div className="create-product-container">
                <div className="container-fluid py-4">

                    {/* Success Alert */}
                    {showSuccessAlert && (
                        <div className="alert alert-success alert-dismissible fade show" role="alert">
                            <i className="bi bi-check-circle me-2"></i>
                            <strong>Success!</strong> Product has been created successfully.
                            <button type="button" className="btn-close" onClick={() => setShowSuccessAlert(false)}></button>
                        </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center mb-10" style={{ flexWrap: "wrap", gap: "10px" }}>
                        <h2 className="page-title">
                            <i className="bi bi-plus-circle me-2"></i>
                            {isEditing ? "Edit Product" : "Create New Product"}                          </h2>

                        <div className="d-flex gap-2">



                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        {isEditing ? "Editing..." : "Publishing..."}
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check-circle me-2"></i>

                                        {isEditing ? "Edit Product" : "Publish Product"}
                                        {/* Publish Product */}
                                    </>
                                )}
                            </button>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            {/* Left Column */}
                            <div className="col-lg-8">

                                {/* Basic Information */}
                                <div className="card mb-4">
                                    <div className="card-header">
                                        <h5 className="mb-0">
                                            <i className="bi bi-info-circle me-2"></i>
                                            Basic Information
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Product Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.productName ? 'is-invalid' : ''}`}
                                                name="productName"
                                                value={formData.productName}
                                                onChange={handleInputChange}
                                                placeholder="e.g., ECO NANO PLUS"
                                            />
                                            {errors.productName && (
                                                <div className="invalid-feedback">{errors.productName}</div>
                                            )}
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">
                                                    Category <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className={`form-select ${errors.category ? 'is-invalid' : ''}`}
                                                    name="category"
                                                    value={formData.category}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select Category</option>
                                                    {categories && categories.length > 0 ? (
                                                        categories.map(cat => (
                                                            <option key={cat._id || cat.id || cat.slug || cat.name} value={cat._id || cat.id || cat.slug || cat.name}>
                                                                {cat.name || cat.title || cat.categoryName || cat.slug || 'Unnamed'}
                                                            </option>
                                                        ))
                                                    ) : null}
                                                </select>
                                                {errors.category && (
                                                    <div className="invalid-feedback">{errors.category}</div>
                                                )}
                                            </div>

                                        </div>


                                        <div className="mb-3">
                                            <label className="form-label">Configuration Type</label>
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="form-check" style={{ display: "flex", alignItems: "center", gap: "0px" }}>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="configType"
                                                        id="configWhatsapp"
                                                        value="WHATSAPP"
                                                        checked={formData.configType === 'WHATSAPP'}
                                                        onChange={handleInputChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="configWhatsapp">
                                                        Whatsapp Config
                                                    </label>
                                                </div>
                                                <div className="form-check" style={{ display: "flex", alignItems: "center", gap: "0px" }}>

                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="configType"
                                                        id="configCustom"
                                                        value="CUSTOM"
                                                        checked={formData.configType === 'CUSTOM'}
                                                        onChange={handleInputChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="configCustom">
                                                        Custom Config
                                                    </label>
                                                </div>
                                            </div>
                                            {formData.configType === 'CUSTOM' && (
                                                <div className="mt-3">
                                                    <label className="form-label">
                                                        Redirection Link <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="url"
                                                        className={`form-control ${errors.redirectionLink ? 'is-invalid' : ''}`}
                                                        name="redirectionLink"
                                                        value={formData.redirectionLink}
                                                        onChange={handleInputChange}
                                                        placeholder="e.g., https://example.com/product"
                                                    />
                                                    {errors.redirectionLink && (
                                                        <div className="invalid-feedback">{errors.redirectionLink}</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>

                                <div className="card mb-4">
                                    <div className="card-header">
                                        <h5 className="mb-0">
                                            <i className="bi bi-currency-dollar me-2"></i>
                                            Pricing
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">
                                                    Original Price (CAD) <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <span className="input-group-text">$</span>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        className={`form-control ${errors.originalPrice ? 'is-invalid' : ''}`}
                                                        name="originalPrice"
                                                        value={formData.originalPrice}
                                                        onChange={handleInputChange}
                                                        onBlur={calculateDiscount}
                                                        placeholder="49.99"
                                                    />
                                                    {errors.originalPrice && (
                                                        <div className="invalid-feedback">{errors.originalPrice}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">
                                                    Current Price (CAD) <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <span className="input-group-text">$</span>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        className={`form-control ${errors.currentPrice ? 'is-invalid' : ''}`}
                                                        name="currentPrice"
                                                        value={formData.currentPrice}
                                                        onChange={handleInputChange}
                                                        onBlur={calculateDiscount}
                                                        placeholder="41.99"
                                                    />
                                                    {errors.currentPrice && (
                                                        <div className="invalid-feedback">{errors.currentPrice}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Discount %</label>
                                                <div className="input-group">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="discountPercentage"
                                                        value={formData.discountPercentage}
                                                        readOnly
                                                        placeholder="Auto"
                                                    />
                                                    <span className="input-group-text">%</span>
                                                </div>
                                                <small className="text-muted">Automatically calculated</small>
                                            </div>
                                        </div>

                                        {/* Price Preview */}
                                        {/* {formData.currentPrice && formData.originalPrice && (
                                            <div className="alert alert-info mt-3">
                                                <strong>Price Preview:</strong>
                                                <div className="d-flex align-items-center gap-3 mt-2">
                                                    <span className="price-display">CAD ${formData.currentPrice}</span>
                                                    {formData.discountPercentage > 0 && (
                                                        <>
                                                            <span className="price-original">CAD ${formData.originalPrice}</span>
                                                            <span className="price-discount">-{formData.discountPercentage}%</span>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        )} */}

                                        {formData.currentPrice && formData.originalPrice && (
                                            <div className="alert alert-info mt-3">
                                                <strong>Price Preview:</strong>
                                                <div className="d-flex align-items-center gap-3 mt-2">
                                                    <span className="price-display">
                                                        CAD ${formatPrice(formData.currentPrice)}
                                                    </span>

                                                    {Number(formData.discountPercentage) > 0 && (
                                                        <>
                                                            <span className="price-original">
                                                                CAD ${formatPrice(formData.originalPrice)}
                                                            </span>
                                                            <span className="price-discount">
                                                                -{formatPercentage(formData.discountPercentage)}%
                                                            </span>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>

                                {/* Product Description */}
                                <div className="card mb-4">
                                    <div className="card-header">
                                        <h5 className="mb-0">
                                            <i className="bi bi-file-text me-2"></i>
                                            Product Description
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <label className="form-label">Short Description</label>
                                            <textarea
                                                className="form-control"
                                                name="shortDescription"
                                                value={formData.shortDescription}
                                                onChange={handleInputChange}
                                                rows="2"
                                                maxLength="200"
                                                placeholder="Brief product highlight (appears under title)"
                                            />
                                            <small className="text-muted">
                                                {formData.shortDescription.length}/200 characters
                                            </small>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Full Description</label>
                                            <textarea
                                                className="form-control"
                                                name="fullDescription"
                                                value={formData.fullDescription}
                                                onChange={handleInputChange}
                                                rows="6"
                                                placeholder="Detailed product description..."
                                            />
                                            <small className="text-muted">
                                                {formData.fullDescription.length} characters
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                {/* Product Images */}
                                <div className="card mb-4">
                                    <div className="card-header">
                                        <h5 className="mb-0">
                                            <i className="bi bi-images me-2"></i>
                                            Product Images
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <label className="form-label">
                                                Main Product Image <span className="text-danger">*</span>
                                            </label>
                                            <div
                                                className={`main-image-upload border rounded p-4 text-center ${isDragging ? 'border-primary bg-light' : ''} ${errors.mainImage ? 'border-danger' : ''}`}
                                                onDragOver={handleDragOver}
                                                onDragLeave={handleDragLeave}
                                                onDrop={(e) => handleDrop(e, 'main')}
                                            >
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={handleMainImageChange}
                                                    id="mainImage"
                                                />
                                                <p className="text-muted mt-2 mb-0">
                                                    <i className="bi bi-cloud-upload me-2"></i>
                                                    Drag & drop or click to upload (Max 5MB)
                                                </p>
                                                {imagePreview.main && (
                                                    <div className="mt-3">
                                                        <img
                                                            src={imagePreview.main}
                                                            alt="Main preview"
                                                            className="img-thumbnail"
                                                            style={{ maxWidth: '300px', maxHeight: '300px' }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            {errors.mainImage && (
                                                <div className="text-danger mt-1"><small>{errors.mainImage}</small></div>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">
                                                Thumbnail Images (Max 4)
                                                {formData.thumbnailImages.length > 0 && (
                                                    <span className="badge bg-secondary ms-2">
                                                        {formData.thumbnailImages.length}/4
                                                    </span>
                                                )}
                                            </label>
                                            <div
                                                className={`border rounded p-4 text-center ${isDragging ? 'border-primary bg-light' : ''}`}
                                                onDragOver={handleDragOver}
                                                onDragLeave={handleDragLeave}
                                                onDrop={(e) => handleDrop(e, 'thumbnails')}
                                            >
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="image/*"
                                                    multiple
                                                    onChange={handleThumbnailChange}
                                                    disabled={formData.thumbnailImages.length >= 4}
                                                />
                                                <small className="text-muted d-block mt-2">
                                                    <i className="bi bi-cloud-upload me-2"></i>
                                                    These appear as side thumbnails on the product page
                                                </small>
                                            </div>

                                            {imagePreview.thumbnails.length > 0 && (
                                                <div className="d-flex flex-wrap gap-2 mt-3">
                                                    {imagePreview.thumbnails.map((preview, index) => (
                                                        <div key={index} className="position-relative">
                                                            <img
                                                                src={preview}
                                                                alt={`Thumbnail ${index + 1}`}
                                                                className="img-thumbnail"
                                                                style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                                                onClick={() => removeThumbnail(index)}
                                                                style={{ padding: '0px ', margin: '4px', borderRadius: "50%", flexShrink: "0", height: "18px", width: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                title="Remove thumbnail"
                                                            >
                                                                <Icon icon="material-symbols:close-rounded" width="15" />

                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Color Variants */}
                                <div className="card mb-4">
                                    <div className="card-header d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px" }}>
                                        <h5 className="mb-0">
                                            <i className="bi bi-palette me-2"></i>
                                            Color Variants <span>(Optional)</span>
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={addVariant}
                                        >
                                            <i className="bi bi-plus-circle me-1"></i>Add Variant
                                        </button>
                                    </div>
                                    <div className="card-body">
                                        {formData.variants.map((variant, index) => (
                                            <div key={index} className="variant-item p-3 mb-3 border rounded">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h6 className="mb-0">
                                                        <i className="bi bi-circle-fill me-2" style={{ fontSize: '10px' }}></i>
                                                        Variant {index + 1}
                                                    </h6>
                                                    {formData.variants.length > 1 && (
                                                        <button
                                                            type="button"

                                                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => removeVariant(index)}
                                                        >
                                                            <Icon icon="mdi:trash-can-outline" className="menu-icon" />
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-5 mb-3">
                                                        <label className="form-label">Color Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={variant.colorName}
                                                            onChange={(e) => handleVariantChange(index, 'colorName', e.target.value)}
                                                            placeholder="e.g., Grape Green, Coral Pink"
                                                        />
                                                    </div>

                                                    <div className="col-md-7 mb-3">
                                                        <label className="form-label">Variant Image</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            accept="image/*"
                                                            onChange={(e) => handleVariantImageChange(index, e.target.files[0])}
                                                        />
                                                        {imagePreview.variants && imagePreview.variants[index] && (
                                                            <div className="mt-2">
                                                                <img src={imagePreview.variants[index]} alt={`Variant ${index + 1}`} className="img-thumbnail" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Specifications */}
                                <div className="card mb-4">
                                    <div className="card-header d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px" }}>
                                        <h5 className="mb-0">
                                            <i className="bi bi-list-ul me-2"></i>
                                            Specifications
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={addSpecification}
                                        >
                                            <i className="bi bi-plus-circle me-1"></i>Add Specification
                                        </button>
                                    </div>
                                    <div className="card-body">
                                        {formData.specifications.map((spec, index) => (
                                            <div key={index} className="row mb-3 align-items-center specifications-row" >
                                                <div className="col-md-4">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={spec.label}
                                                        onChange={(e) => handleSpecificationChange(index, 'label', e.target.value)}
                                                        placeholder="Label (e.g., Battery)"
                                                    />
                                                </div>
                                                <div className="col-md-7">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={spec.value}
                                                        onChange={(e) => handleSpecificationChange(index, 'value', e.target.value)}
                                                        placeholder="Value (e.g., 1400mAh Long-Lasting Battery)"
                                                    />
                                                </div>
                                                <div className="col-md-1">
                                                    {formData.specifications.length > 1 && (
                                                        <button
                                                            type="button"
                                                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                                            className="btn btn-sm btn-outline-danger w-100"
                                                            onClick={() => removeSpecification(index)}
                                                            title="Remove specification"
                                                        >
                                                            <Icon icon="mdi:trash-can-outline" className="menu-icon" />
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>



                            </div>

                            <div className="col-lg-4">

                                <div className="card mb-4 sticky-top" >
                                    <div className="card-header">
                                        <h5 className="mb-0">
                                            <i className="bi bi-gear me-2"></i>
                                            SEO Settings (optional)
                                        </h5>
                                    </div>

                                    <div className="card-body">
                                        <div className="mb-3">
                                            <label className="form-label">Meta Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="metaTitle"
                                                value={formData.metaTitle}
                                                onChange={handleInputChange}
                                                placeholder="SEO optimized title (60 characters recommended)"
                                                maxLength="60"
                                            />
                                            <small className="text-muted">{formData.metaTitle.length}/60</small>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Meta Description</label>
                                            <textarea
                                                className="form-control"
                                                name="metaDescription"
                                                value={formData.metaDescription}
                                                onChange={handleInputChange}
                                                rows="3"
                                                placeholder="SEO description (160 characters recommended)"
                                                maxLength="160"
                                            />
                                            <small className="text-muted">{formData.metaDescription.length}/160</small>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Tags</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="tags"
                                                value={formData.tags}
                                                onChange={handleInputChange}
                                                placeholder="vape, eco, nano, plus (comma separated)"
                                            />
                                            <small className="text-muted">Separate tags with commas</small>
                                        </div>
                                    </div>

                                </div>



                            </div>
                        </div>
                    </form>
                </div>
            </div>



        </MasterLayout>
    )
}

export default CreateProducts